import { LocationServiceOverride } from '~/storm'

export function keyOverrideByLocationDay({ location_uuid, scheduled_date }: Pick<LocationServiceOverride, 'location_uuid' | 'scheduled_date'>) {
    return `${location_uuid}__${scheduled_date}`
}

export type ClosedReason = LocationServiceOverride['closed_reason'] | 'service_period'

export const closedReasonText: Record<ClosedReason, string> = {
    vacation: 'Ferie',
    insufficient_patients: 'For få pasienter på venteliste',
    insufficient_surgeons: 'Mangler kirurger',
    insufficient_staff: 'Mangler personell',
    insufficient_equipment: 'Mangler utstyr',
    planned_maintenance: 'Planlagt vedlikehold',
    other: 'Annet',
    service_period: 'Stengt stue',
}

export const closedReasons = [
    'insufficient_surgeons',
    'insufficient_staff',
    'insufficient_equipment',
    'insufficient_patients',
    'vacation',
    'planned_maintenance',
    'other',
] as const satisfies Array<LocationServiceOverride['closed_reason']>

export const closedReasonOptions = closedReasons.map(value => ({ value, label: closedReasonText[value] }))
